const insertAt = (str: string, sub: string, pos: number) =>
  `${str.slice(0, pos)}${sub}${str.slice(pos)}`;

export function formatHealthcardNumber(value: string) {
  const digits = value.replace(/\D/g, "");
  let formatted = digits;
  if (digits.length > 4) formatted = insertAt(formatted, "-", 4);
  if (digits.length > 7) formatted = insertAt(formatted, "-", 8);
  return formatted;
}

export function formatHealthcardVersion(value: string) {
  return value.toUpperCase();
}

export function formatPhoneNumber(value: string) {
  const digits = value.replace(/\D/g, "");
  let formatted = digits;
  if (digits.length > 3) formatted = insertAt(formatted, "-", 3);
  if (digits.length > 6) formatted = insertAt(formatted, "-", 7);
  return formatted;
}
